import { Box, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import apiMcu from "api/mcu";
import { TableHeaderCC } from "components/Table";
import { headCellsMCUStatus } from "components/Table/Functions";
import { useTableCC } from "hooks";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { transHeadCells } from "utils/functions";
import { secondsToHMS } from "../MCUStatus";

const TableInfoRoom = ({nodeId, roomNumber}) => {
    const { sizeRow } = useTableCC();
    const {t} = useTranslation();
    const [dataMembers, setDataMembers] = useState([]);
    const ref = useRef(null);

    const apiGetRoomInfo = (nodeId, room) => {
        return apiMcu.getRoomInfo( nodeId, room)
    }

    useEffect(() => {
        if(!ref.current){
            ref.current = setInterval(() => {
                apiGetRoomInfo(nodeId, roomNumber)
                .then((result) => {
                    setDataMembers(result?.members);               
                })
                .catch(error => {
                })
            }, 5000);
        }

        return () => {
            clearInterval(ref.current);
        }
    // eslint-disable-next-line
    }, [nodeId, roomNumber])

    return (
        <Box sx={{ marginTop: '12px' }}>
            <TableContainer
                sx={{
                    overflowX: 'initial',
                    overflowY: 'auto',
                    maxHeight: '565px',
                }}
            >
                <Table stickyHeader sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={sizeRow}>
                    <TableHeaderCC headCellTable={transHeadCells(headCellsMCUStatus, t)} styleHeadCell={{ boxShadow: 'none !important', borderBottom: '1px solid rgb(209, 209, 209) !important' }} />
                    <TableBody>
                        {
                            dataMembers?.map((member, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={member.id} sx={{ cursor: 'auto', backgroundColor: '#fff !important' }}>
                                        <TableCell align="center" style={{fontWeight: '600'}}>{index + 1}</TableCell>
                                        <TableCell align="left" style={{ width: '397px', fontWeight: '600' }}>{member.callerName}</TableCell>
                                        <TableCell align="right" style={{fontWeight: '600'}}>{secondsToHMS(member.joinTimeDuration)}</TableCell>
                                        <TableCell align="center" style={{ width: '420px', fontWeight: '600' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'start', flexDirection: 'column', padding: '9px 4px' }}>
                                                <Box><span style={{ height: '24px', fontWeight: '700' }}>Audio In:</span> {member.audioCodecIn ? member.audioCodecIn : '-'}</Box>
                                                <Box><span style={{ height: '24px', fontWeight: '700' }}>Audio Out:</span> {member.audioCodecOut ? member.audioCodecOut : '-'}</Box>
                                                <Box><span style={{ height: '24px', fontWeight: '700' }}>Video In:</span> {member.videoCodecIn ? `${member.videoCodecIn}@${member.videoWidth}x${member.videoHeight}` : '-'}</Box>
                                                <Box><span style={{ height: '24px', fontWeight: '700' }}>Video Out:</span> {member.videoCodecOut ? `${member.videoCodecOut}@${member.videoWidth}x${member.videoHeight}` : '-'}</Box>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center" style={{ width: '194.75px', fontWeight: '600' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'end', flexDirection: 'column', padding: '9px 4px' }}>
                                                <Box>{member.senderPacketCount ? member.senderPacketCount : '-'}</Box>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center" style={{ width: '194.75px', fontWeight: '600' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'end', flexDirection: 'column', padding: '9px 4px' }}>
                                                <Box>{member.rtt ? `${(parseFloat(member.rtt)*1000).toFixed(3)}ms` : '-'}</Box>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center" style={{ width: '194.75px', fontWeight: '600' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'end', flexDirection: 'column', padding: '9px 4px' }}>
                                                <Box>{member.videoFps ? member.videoFps : '-' }</Box>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center" style={{ width: '194.75px', fontWeight: '600' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'end', flexDirection: 'column', padding: '9px 4px' }}>
                                                <Box>{(member.lossPercent || parseFloat(member.lossPercent) === 0) ? `${member.lossPercent.toFixed(3)}%` : '-'}</Box>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default TableInfoRoom;